import type { ILoginLocale } from '@/Pages/Onboard/Login/Locale/Login.locale';

const esES: ILoginLocale = {
  title: 'Iniciar sesión en {brand}',
  email: {
    label: 'Correo Electrónico',
    placeholder: 'ejemplo@correo.com',
    error: 'Por favor ingresa un correo electrónico válido',
  },
  password: {
    label: 'Contraseña',
    placeholder: 'Tu contraseña',
    error: 'La contraseña es obligatoria',
  },
  button: {
    login: 'Iniciar Sesión',
    forgotPassword: '¿Olvidaste tu contraseña?',
  },
  terms: {
    message1: 'Al iniciar sesión, aceptas nuestra ',
    message2: '',
    terms: 'Términos de Servicio',
    privacy: 'Política de Privacidad',
  },
  errors: {
    invalidCredentials: 'Correo electrónico o contraseña inválidos',
    accountLocked:
      'Tu cuenta ha sido bloqueada debido a múltiples intentos fallidos de inicio de sesión',
    accountDisabled: 'Tu cuenta ha sido deshabilitada. Por favor contacta a soporte',
    networkError: 'Error de red. Por favor verifica tu conexión e intenta nuevamente',
    twoFactorRequired: 'Se requiere autenticación de dos factores',
  },
};
export { esES };
